import { Modal } from 'antd';
import Content from './Content';
import { useTranslate } from '@tolgee/react';

interface Props {
  visible: boolean;
  onClose?: () => void;
}

const ExportCenterModal = (props: Props) => {
  const { visible, onClose } = props;
  const { t } = useTranslate();

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      title={t('export_modal_export_record')}
      closable
      destroyOnClose
    >
      <div className="w-full overflow-x-auto">
        <Content />
      </div>
    </Modal>
  );
};

export default ExportCenterModal;
